<template>
    <div class="container">
        <dis_tabs></dis_tabs>
        <div class="bg_fff">
            <div class="wrap  mt15 flex pl20 pr20 pt20 pb20">
                <el-table border size="mini" :data="tableList" :header-cell-style="{backgroundColor:'#fafafa'}">
                    <el-table-column label="状态" align="center" prop="ddzt" :formatter="orderState"></el-table-column>
                    <el-table-column label="编号" align="center" prop="ddid"></el-table-column>
                    <el-table-column label="姓名" align="center" prop="hzxm"></el-table-column>
                    <el-table-column label="手机号" align="center" prop="sjh"></el-table-column>
                    <el-table-column label="申请时间" align="center" prop="createTime"  :formatter="formatTime"></el-table-column>
                    <el-table-column label="申请医院" align="center" prop="initHosName"></el-table-column>
                    <el-table-column label="申请医生" align="center" prop="initDocName"></el-table-column>
                    <el-table-column label="预约医院" align="center" prop="yymc"></el-table-column>
                    <el-table-column label="预约科室" align="center" prop="ksmc"></el-table-column>
                    <el-table-column label="预约医生" align="center" prop="ysmc" :formatter="formatDoc"></el-table-column>
                    <el-table-column label="就诊时间" align="center" prop="_hysj"></el-table-column>
                    <el-table-column label="就诊序号" align="center" prop="numno"></el-table-column>
                </el-table>
            </div>
            <div class="pt15" style="text-align: center">
                <el-pagination
                        @current-change="pageChange"
                        :page-size="page.pageSize"
                        :current-page="page.pageNum"
                        layout="total, prev, pager, next, jumper"
                        :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import dis_tabs from "../../components/dis/dis-tabs"
    import {disService} from "../../lib/service/dis"
    import {timeFormat} from "../../lib/utils"
    import {disDocCache,disDepCache,disTypeCache} from '../../lib/cache/DisOrder'
    export default {
        name: "Week",
        components:{dis_tabs},
        data(){
            return {
                tableList:[],
                page:{
                    pageNum:1,
                    pageSize:20,
                    total:0
                }
            }
        },
        methods:{
            pageChange(num){
              this.page.pageNum = num;
              this.queryTable();
            },
            //查询未来会诊列表
           async queryTable(){
                let form = {};
                form.pageNum = this.page.pageNum;
                form.pageSize= this.page.pageSize;
                form.orderType = "2";
                if(disTypeCache.get() == '1'){
                    form.bookHosId = disDocCache.get().bookHosId;
                    form.bookDeptId = disDocCache.get().bookDeptId;
                    form.bookDocId = disDocCache.get().bookDocId;
                }else{
                    form.bookHosId = disDepCache.get().bookHosId;
                    form.bookDeptId = disDepCache.get().bookDeptId;
                }
                const {list,obj} = await disService.queryReceiveList(form);
               if(obj.list.length == 0){
                   this.page.total = 0;
                   this.tableList = [];
                   return
               }
               const table  = this.merge(obj.list,list);
               this.page.total = obj.page.total*1;
               this.tableList = table;
            },
            //处理数据
            merge(l1,l2){
                const backArray = [];//返回的数据
                for(let o of l1){
                    let order =  l2.find(val => {
                        return o.ddid == val.id
                    })
                    let obj = Object.assign({},o,order);
                    obj._hysj = obj.ghrq +' '+ obj.numtime;
                    backArray.push(obj);
                }
                return backArray;
            },
            formatTime(row, column, cellValue){
                if(cellValue){
                    return   timeFormat(cellValue,'%Y-%m-%d %H:%M');
                }
            },
            formatDoc(row, column, cellValue){
                if(cellValue || cellValue != undefined){
                     return cellValue
                }else{
                     return '普通号'
                }
            },
            //订单状态
            orderState(row, column, cellValue){
                switch (cellValue*1) {
                    case 1 :
                        return "待就诊"
                    case 3 :
                        return "已取消"
                    case 5 :
                        return "已就诊"
                    case 6 :
                        return "待就诊"
                    case 7 :
                        return "待就诊"
                }
            }
        },
        mounted() {
            this.queryTable();
        }
    }
</script>

<style scoped>

</style>